import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { WorkupPersonAttachment } from '../../types';

@Injectable({ providedIn: 'root' })
export class AttachmentsService {
  private readonly http = inject(HttpClient);

  loadAttachments(): Observable<Array<WorkupPersonAttachment>> {
    return this.http.get<Array<WorkupPersonAttachment>>(`api/v1/tickets/workup/current/person/attachments`);
  }

  downloadAttachmentByType(attachmentType: string): Observable<Blob> {
    const url = `api/v1/tickets/workup/current/person/attachments/file`;
    return this.http.get(url, { params: { type: attachmentType }, responseType: 'blob' });
  }

  loadParkingAttachments(): Observable<Array<WorkupPersonAttachment>> {
    return this.http.get<Array<WorkupPersonAttachment>>(`api/v1/tickets/workup/current/attachments`);
  }

  downloadParkingAttachment(id: string): Observable<Blob> {
    const url = `api/v1/tickets/workup/current/attachments/${id}/file`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
